import React from 'react';
import ProjectOverviewChart from './ProjectOverviewChart';

const ProjectOverviewTab = (props) => {
    return (
        <>
            <div className="card overflow-hidden overview-card-compact">                
                <ProjectOverviewChart
                    height={props.height}
                    orders={props.orders || []}
                    materials={props.materials || []}
                    recipes={props.recipes || []}
                    products={props.products || []}
                    sales={props.sales}
                />
            </div>   
        </>
    );
};

export default ProjectOverviewTab;
